import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"

import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeBACENCadastroConglomeradoTable = ({filters, endpoint, loading, disableToolbar})  => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        if (filters && filters.length > 0) {
            onFilter(filters, 25, 0)
        } else {
            loadData()
        }
    }, [])

    const loadData = () => {
        loading(true)
        dataLakeService.loadPaginationEndpoint(endpoint).then((response) => {
            loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "CPFCNPJ": null,
            "CodigoIF": null,
            "MesBase": null,
            "NomeIF": null,
            "InicioAtividade": null,
            "TCB": null,
            "TD": null,
            "TC": null,
            "SegmentoTB": null,
            "Atividade": null,
            "UF": null,
            "Municipio": null,
            "SR": null,
            "CodigoConglomeradoFinanceiro": null,
            "CodigoConglomeradoPrudencial": null,
            "CNPJInstituicaoLider": null,
            "Situacao": null
        }

        loading(true)
        return dataLakeService.createTableEndpoint(endpoint, body).then(() => {
            loading(false)
            loadData(0, 25)
        }).catch((err) => {
            loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, CPFCNPJ, CodigoIF, MesBase, NomeIF, InicioAtividade, TCB, TD, TC, 
            SegmentoTB, Atividade, UF, Municipio, SR, CodigoConglomeradoFinanceiro,
            CodigoConglomeradoPrudencial, CNPJInstituicaoLider, Situacao
        } = newRow

        const body = {
            "CPFCNPJ": CPFCNPJ,
            "CodigoIF": CodigoIF,
            "MesBase": MesBase,
            "NomeIF": NomeIF,
            "InicioAtividade": InicioAtividade,
            "TCB": TCB,
            "TD": TD,
            "TC": TC,
            "SegmentoTB": SegmentoTB,
            "Atividade": Atividade,
            "UF": UF,
            "Municipio": Municipio,
            "SR": SR,
            "CodigoConglomeradoFinanceiro": CodigoConglomeradoFinanceiro,
            "CodigoConglomeradoPrudencial": CodigoConglomeradoPrudencial,
            "CNPJInstituicaoLider": CNPJInstituicaoLider,
            "Situacao": Situacao
        }

        loading(true)
        return dataLakeService.updateTableEndpoint(endpoint, ID, body).then(() => {
            loading(false)
        }).catch((err) => {
            loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(endpoint, ID).then(() => {
            loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        loading(true)
        dataLakeService.loadPaginationEndpoint(`${endpoint}?${query}`, query, limit, offset).then((response) => {
            loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CPFCNPJ',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CodigoIF',
            headerName: 'CodigoIF',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'MesBase',
            headerName: 'MesBase',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'NomeIF',
            headerName: 'NomeIF',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'InicioAtividade',
            headerName: 'InicioAtividade',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TCB',
            headerName: 'TCB',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TD',
            headerName: 'TD',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TC',
            headerName: 'TC',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SegmentoTB',
            headerName: 'SegmentoTB',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Atividade',
            headerName: 'Atividade',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'UF',
            headerName: 'UF',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Municipio',
            headerName: 'Municipio',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SR',
            headerName: 'SR',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CodigoConglomeradoFinanceiro',
            headerName: 'CodigoConglomeradoFinanceiro',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CodigoConglomeradoPrudencial',
            headerName: 'CodigoConglomeradoPrudencial',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CNPJInstituicaoLider',
            headerName: 'CNPJInstituicaoLider',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Situacao',
            headerName: 'Situacao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                disableToolbar={disableToolbar ? disableToolbar : false}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeBACENCadastroConglomeradoTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    filters: PropTypes.array,
    disableToolbar: PropTypes.bool,
}

export default ParameterDatalakeBACENCadastroConglomeradoTable
